/**
 * @generated SignedSource<<ce3c687359a82a50ed77a0ec57dc2466>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type entityOnelineMenuLiteQueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly name?: string;
    readonly urlAlias?: string;
    readonly urlRedirect?: {
      readonly toUrl: string;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  };
  readonly " $fragmentType": "entityOnelineMenuLiteQueueItemsEdge";
}>;
export type entityOnelineMenuLiteQueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: entityOnelineMenuLiteQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"entityOnelineMenuLiteQueueItemsEdge">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "entityOnelineMenuLiteQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "type": "Topic",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "UrlRedirect",
              "kind": "LinkedField",
              "name": "urlRedirect",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "toUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Section",
          "abstractKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};
})();

(node as any).hash = "e39c3ed3858d0ca5d4be49101c8028ca";

export default node;
